import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { Box, Button, Select, Heading, Text, useToast } from '@chakra-ui/react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const ChangeQuestionCategory = () => {
  const [categories, setCategories] = useState([]);
  const [sourceCategory, setSourceCategory] = useState(null);
  const [targetCategory, setTargetCategory] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const toast = useToast();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/categories`);
        setCategories(response.data.$values || response.data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
  }, []);

  const handleSourceCategoryChange = async (e) => {
    const categoryId = e.target.value;
    setSourceCategory(categoryId);
    setQuestions([]); // Clear the current list
    if (categoryId) {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/QuestionCategories/category/${categoryId}`);
        setQuestions(response.data.$values || response.data);
      } catch (error) {
        console.error('Error fetching questions:', error);
      }
    } else {
      setQuestions([]); // Clear the current list if no category is selected
    }
  };

  const handleMove = async () => {
    if (!targetCategory) {
      toast({
        title: 'Please select a target category',
        status: 'warning',
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    try {
      const selectedNodes = gridApi.getSelectedNodes();
      const selectedQuestions = selectedNodes.map((node) => node.data.questionId);

      await axios.post(`${process.env.REACT_APP_API_URL}/api/QuestionCategories/change-category`, {
        questionIds: selectedQuestions,
        newCategoryId: targetCategory,
      });

      toast({
        title: 'Questions moved successfully',
        status: 'success',
        duration: 5000,
        isClosable: true,
      });

      // Refresh questions list after moving
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/QuestionCategories/category/${sourceCategory}`);
      setQuestions(response.data.$values || response.data);
    } catch (error) {
      console.error('Error moving questions:', error);
      toast({
        title: 'Error moving questions',
        description: error.response?.data || error.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const columnDefs = useMemo(() => [
    { headerName: 'Select', field: 'questionId', checkboxSelection: true,width: 30  },
    { headerName: 'Serial No', valueGetter: 'node.rowIndex + 1', width: 30 },
    { headerName: 'Question ID', field: 'questionId', sortable: true, filter: true },
    { headerName: 'Question Text', field: 'questionText', sortable: true, filter: true },
   
  ], []);

  const defaultColDef = useMemo(() => ({
    flex: 1,
    minWidth: 100,
    resizable: true,
    sortable: true,
    filter: true,
    floatingFilter: true,
  }), []);

  return (
    <Box p={8}>
      <Heading mb={6}>Change Question Category</Heading>

      <Text fontSize="lg" mb={2}>Source Category</Text>
      <Select placeholder="Select Source Category" onChange={handleSourceCategoryChange} mb={4}>
        {categories.map((category) => (
          <option key={category.categoryId} value={category.categoryId}>
            {category.categoryName}
          </option>
        ))}
      </Select>

      <Text fontSize="lg" mb={2}>Target Category</Text>
      <Select placeholder="Select Target Category" onChange={(e) => setTargetCategory(e.target.value)} mb={4}>
        {categories.map((category) => (
          <option key={category.categoryId} value={category.categoryId}>
            {category.categoryName}
          </option>
        ))}
      </Select>

      <Button onClick={handleMove} colorScheme="blue" mb={4}>
        Move
      </Button>

      <Text mb={4}>Total Questions: {questions.length}</Text>
      <div className="ag-theme-alpine" style={{ height: '400px', width: '100%' }}>
        <AgGridReact
          columnDefs={columnDefs}
          rowData={questions}
          defaultColDef={defaultColDef}
          rowSelection="multiple"
          onGridReady={(params) => setGridApi(params.api)}
        />
      </div>
    </Box>
  );
};

export default ChangeQuestionCategory;
